<!-- components/Layout/Navbar/ColorThemePicker.vue -->
<script setup lang="ts">
import { ref, computed, toRefs } from 'vue'
import type { MenuColorTheme } from '~/utils/menuColorThemes'

const props = defineProps<{
  themes: MenuColorTheme[]
  modelValue: string
  theme?: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', key: string): void
}>()

const { theme } = toRefs(props)
const isOpen = ref(false)

const current = computed(() => props.themes.find(t => t.key === props.modelValue) ?? props.themes[0])

const buttonClass = 'bg-3a-nav-btn' + (theme.value == 'dark' ? ' dark ' : '')

function select(key: string) {
  emit('update:modelValue', key)
  isOpen.value = false
}
</script>

<template>
  <div class="relative inline-block text-left">
    <!-- Button to toggle dropdown -->
    <button
      type="button"
      @click="isOpen = !isOpen"
      :class='buttonClass+"  inline-flex items-center justify-center gap-2 px-3 py-2 rounded hover:bg-white/50 dark:hover:bg-white/50 hover:text-black transition"'
    >
    <UIcon name="i-lucide-palette" class="text-white" />
       <!-- <span class="h-3.5 w-3.5 rounded-full inline-block shrink-0 border border-white/40" :style="{ background: current?.navbar }"></span> -->
      <!--{{ current?.label }}-->
    </button>
    <!-- Dropdown menu opens UP, same pattern as LanguageSwitcher -->
    <div
      v-if="isOpen"
      class="absolute left-0 bottom-full mb-2 w-44 bg-white dark:bg-white border border-gray-200 rounded shadow-lg z-50 text-black"
    >
      <ul>
        <li v-for="t in themes" :key="t.key">
          <button
            type="button"
            @click="select(t.key)"
            class="w-full text-left px-3 py-2 flex items-center gap-2
               hover:bg-gray-100 dark:hover:bg-gray-200 transition
               text-black cursor-pointer"
          >
            <span class="h-3.5 w-3.5 rounded-full inline-block shrink-0 border border-black/10" :style="{ background: t.navbar }"></span>
            {{ t.label }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>
